<template>
  <div class="relative" ref="containerRef">
    <button
      ref="buttonRef"
      @click="toggle"
      class="flex items-center gap-1"
    >
      {{ label }}
    </button>

    <div
      v-show="open"
      class="absolute right-0 mt-2 z-50 bg-white rounded-md shadow-lg ring-1 ring-black/5"
    >
      <ul class="py-1">
        <li v-for="item in items" :key="item.href">
          <a
            :href="item.href"
            class="block px-4 py-2 text-sm hover:bg-neutral-light"
          >{{ item.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  label: { type: String, default: '' },
  items: { type: Array, default: () => [] },
  open: { type: Boolean, default: false },
});

const open = ref(props.open);
const containerRef = ref(null);
const buttonRef = ref(null);

function toggle() {
  if (open.value) {
    open.value = false;
  } else {
    buttonRef.value?.focus();
    open.value = true;
  }
}

function handleClickOutside(event) {
  if (containerRef.value && !containerRef.value.contains(event.target)) {
    open.value = false;
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
</script>
